enum Mutations {
  SET_PAYMENT_PAGE_DATA = 'setPaymentPageData',
  SET_PAYMENT_FROM_BE = 'setPaymentFromBE',
}

export default Mutations
